import React from 'react'
import Login from 'components/Login'

export default function LoginPage () {
  return <>
    <h2>Login</h2>
    <Login />
  </>
}